var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDuplicate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#A1A5B7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745 5108 c-27 -5 -87 -27 -133 -48 -108 -51 -222 -161 -270 -260 -66 -136 -62 -31 -62 -1702 0 -1049 3 -1533 11 -1570 19 -94 85 -213 159 -288 75 -74 194 -140 288 -159 74 -15 2630 -15 2704 0 97 20 211 83 286 158 76 76 142 194 161 289 8 36 11 433 11 1260 0 1302 1 1267 -53 1402 -52 127 -85 168 -377 463 -303 307 -365 358 -498 409 -150 59 -134 58 -1200 57 -571 -1 -998 -5 -1027 -11z m2044 -323 c117 -28 149 -52 434 -335 255 -252 270 -269 310 -349 l42 -84 3 -1201 c2 -926 0 -1211 -10 -1246 -16 -59 -105 -151 -164 -168 -60 -17 -2568 -17 -2628 0 -55 16 -148 109 -164 164 -9 32 -12 395 -12 1535 l0 1494 24 51 c27 58 91 117 150 138 63 22 1921 23 2015 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2237 3616 c-49 -18 -64 -32 -89 -80 -37 -73 -13 -153 62 -203 l33 -23 847 0 847 0 33 23 c48 32 72 69 77 119 7 58 -23 118 -74 149 l-38 24 -830 2 c-677 2 -837 0 -868 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2237 2976 c-49 -18 -64 -32 -89 -80 -37 -73 -13 -153 62 -203 l33 -23 847 0 847 0 33 23 c48 32 72 69 77 119 7 58 -23 118 -74 149 l-38 24 -830 2 c-677 2 -837 0 -868 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2237 2336 c-49 -18 -64 -32 -89 -80 -37 -73 -13 -153 62 -203 l33 -23 847 0 847 0 33 23 c48 32 72 69 77 119 7 58 -23 118 -74 149 l-38 24 -830 2 c-677 2 -837 0 -868 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 4583 c-102 -14 -220 -66 -307 -137 -69 -56 -150 -174 -180 -264 l-23 -67 -3 -1790 c-3 -1993 -7 -1862 66 -2007 45 -90 151 -199 239 -246 34 -18 96 -41 139 -52 75 -19 115 -20 1418 -20 1112 0 1352 3 1407 14 207 44 391 222 444 431 21 83 20 276 -1 321 -24 50 -68 77 -133 82 -70 5 -115 -22 -148 -88 -19 -37 -23 -61 -23 -140 0 -115 -24 -176 -90 -233 -84 -72 13 -68 -1471 -65 -1304 3 -1335 3 -1374 23 -50 25 -105 80 -130 130 -20 39 -20 70 -20 1820 l0 1780 22 40 c28 53 89 110 138 131 25 10 84 19 156 23 96 6 120 11 146 29 63 45 83 149 40 213 -37 56 -96 79 -197 78 -47 -1 -98 -4 -115 -6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.20943d26.svg";
export { ForwardRef as ReactComponent };